






































































































































import { Component, Prop } from 'vue-property-decorator';
import Availability from '@/models/Workers/Availability';
//import WorkerAvailability from '@/components/Workers/WorkerAvailabilityDetails.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import WorkType from '@/models/Shared/WorkType';

@Component({
  name: 'WorkerProfilePermSummary',
  components: { }
})
export default class extends GiganautVue {

    @Prop({required: true})
    workerProfile: WorkerProfileDto

	workType = WorkType;
}
